// extracted by mini-css-extract-plugin
module.exports = {"sleepPosition":"sleepPositions-module--sleepPosition--VVIPZ"};